"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[48713],{

/***/ 41110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ AuthModalType; },
/* harmony export */   "X": function() { return /* binding */ AuthModalStatus; }
/* harmony export */ });
var AuthModalType;
(function(AuthModalType) {
    AuthModalType["LOGIN"] = "login";
    AuthModalType["REGISTER"] = "register";
    AuthModalType["PROGRESS"] = "progress";
})(AuthModalType || (AuthModalType = {}));
var AuthModalStatus;
(function(AuthModalStatus) {
    AuthModalStatus[AuthModalStatus["UNREGISTERED"] = 0] = "UNREGISTERED";
    AuthModalStatus[AuthModalStatus["INCOMPLETE"] = 1] = "INCOMPLETE";
    AuthModalStatus[AuthModalStatus["CS"] = 2] = "CS";
    AuthModalStatus[AuthModalStatus["KSEI"] = 3] = "KSEI";
    AuthModalStatus[AuthModalStatus["RDN"] = 4] = "RDN";
    AuthModalStatus[AuthModalStatus["REJECTED"] = 99] = "REJECTED";
    AuthModalStatus[AuthModalStatus["COMPLETED"] = 100] = "COMPLETED";
})(AuthModalStatus || (AuthModalStatus = {}));


/***/ }),

/***/ 17921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ formatShiftedCurrency; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "VZ": function() { return /* binding */ getMostMinMaxAmountRules; },
/* harmony export */   "_j": function() { return /* binding */ adjustCursorPosition; },
/* harmony export */   "bF": function() { return /* binding */ updateCursorPosition; },
/* harmony export */   "i$": function() { return /* binding */ isOverDailyLimit; },
/* harmony export */   "iM": function() { return /* binding */ formatPricePercentage; },
/* harmony export */   "kI": function() { return /* binding */ isUnderDailyLimit; },
/* harmony export */   "qF": function() { return /* binding */ formatBondDate; },
/* harmony export */   "uJ": function() { return /* binding */ formatBondCurrency; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);


// eslint-disable-next-line import/prefer-default-export
var formatBondDate = function(date) {
    if (!date) {
        return "-";
    }
    var formatFullMonthId = Intl.DateTimeFormat("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric"
    });
    return formatFullMonthId.format(new Date(date));
};
var formatBondCurrency = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never", currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "IDR";
    return Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(value).replace(/\s+/g, "");
};
var formatPricePercentage = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never";
    if (typeof value !== "number") {
        return "-";
    }
    var rawValue = value / 100;
    return Intl.NumberFormat("en-US", {
        style: "percent",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(rawValue);
};
var formatCurrency = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Rp";
    return "".concat(currency).concat(Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    }));
};
var formatShiftedCurrency = function(value) {
    var fixZero = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, fractionDigits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, currency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Rp";
    var isNegative = value <= 0;
    var absoluteValue = Math.abs(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
    var formattedValue = "".concat(currency).concat(absoluteValue);
    if (fixZero && value === 0) return "".concat(formattedValue);
    return "".concat(isNegative ? "- " : "").concat(formattedValue);
};
var formatPrice = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
};
var formatNumber = function(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
};
var isOverDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && remaining < amount.min && (inputValue > remaining || inputValue > dailyMax);
};
var isUnderDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && inputValue <= dailyMax && remaining >= amount.min && inputValue > remaining;
};
var getMostMinMaxAmountRules = function(methods) {
    if (methods === null || methods === void 0 ? void 0 : methods.length) {
        var _Math, _Math1;
        var amounts = methods.map(function(method) {
            return method.amount;
        });
        var min = (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.min;
        })));
        var max = (_Math1 = Math).max.apply(_Math1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.max;
        })));
        return {
            min: min,
            max: max
        };
    }
    return {
        min: 0,
        max: 0
    };
};
var updateCursorPosition = function(event, newCursorPosition) {
    window.requestAnimationFrame(function() {
        var inputElement = event.target;
        inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
    });
};
var adjustCursorPosition = function(event, cursorPosition, originalValue, formattedValue) {
    var commaCountBefore = originalValue.slice(0, cursorPosition).split(",").length - 1;
    var commaCountAfter = formattedValue.slice(0, cursorPosition).split(",").length - 1;
    var adjustment = commaCountAfter - commaCountBefore;
    var newCursorPosition = formattedValue === "0" ? 1 : cursorPosition + adjustment;
    updateCursorPosition(event, newCursorPosition);
};


/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export isElementTypeOf */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var isElementTypeOf = function(target, element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(target) && target.type === element;
};
var Else = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
var If = function(props) {
    var condition = props.condition, children = props.children;
    if (condition) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).filter(function(child) {
                return !isElementTypeOf(child, Else);
            })
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
        if (isElementTypeOf(child, Else)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child);
        }
        return null;
    });
};
If.Else = Else;
/* harmony default export */ __webpack_exports__["Z"] = (If);


/***/ }),

/***/ 48713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header_Web; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var slice = __webpack_require__(48153);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/lib/entities/notification/useNotificationData.ts
var useNotificationData = __webpack_require__(89790);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSearchCompanyModalStore.ts
var useSearchCompanyModalStore = __webpack_require__(5612);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Header/Search/index.jsx + 2 modules
var Search = __webpack_require__(39809);
// EXTERNAL MODULE: ./src/global/Header/Navbar/index.jsx + 22 modules
var Navbar = __webpack_require__(70826);
// EXTERNAL MODULE: ./src/global/Header/Message/index.jsx + 9 modules
var Message = __webpack_require__(27271);
// EXTERNAL MODULE: ./src/global/Header/Notification/index.tsx + 16 modules
var Notification = __webpack_require__(25045);
// EXTERNAL MODULE: ./src/global/Header/ProfileMenu/index.jsx + 15 modules
var ProfileMenu = __webpack_require__(97513);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@deprecated-ui/header/index.js + 2 modules
var header = __webpack_require__(37944);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var AuthModal_store = __webpack_require__(70175);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Header/InitialTrading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  align-items: center;\n  border-left: 1px solid ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  flex-direction: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n  z-index: 2;\n\n  ::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    top: 100%;\n    right: 0;\n    height: ",
        ";\n    background: ",
        ";\n    z-index: 2;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  height: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ButtonTrading = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-fa3dde74-0"
})(_templateObject(), color/* default.lowgray */.Z.lowgray, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return minimize ? "space-between" : "space-around";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "16px 0" : "0 16px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "column" : "row";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "110px" : "145px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "101px" : "60px";
}, function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return isActive ? "1px" : 0;
}, color/* default.light */.Z.light);
var ButtonTradingGreen = (0,styled_components_browser_esm/* default */.ZP)(ButtonTrading).withConfig({
    componentId: "sc-fa3dde74-1"
})(_templateObject1(), function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return isActive ? color/* default.light */.Z.light : "linear-gradient(-29deg, #46aa9e, #3fb9aa)";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "101px" : "61px";
});
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/global/Header/InitialTrading/ButtonTradingFill.jsx









var ButtonTradingFill = function(_param) /*#__PURE__*/ {
    var isActive = _param.isActive, minimize = _param.minimize, label = _param.label, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "isActive",
        "minimize",
        "label"
    ]);
    return (0,jsx_runtime.jsxs)(ButtonTradingGreen, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isActive: isActive,
        minimize: minimize
    }, otherProps), {
        "data-cy": "top-navbar-button-start-trading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: minimize ? "left" : "center",
                color: isActive ? color/* default.trading */.Z.trading : color/* default.light */.Z.light,
                family: "bold",
                size: "15px",
                children: label
            }),
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                size: "16px",
                style: {
                    marginTop: "-10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                    className: "icon-toolbar_down",
                    color: isActive ? color/* default.trading */.Z.trading : color/* default.light */.Z.light
                })
            })
        ]
    }));
};
ButtonTradingFill.propTypes = {
    isActive: (prop_types_default()).bool,
    minimize: (prop_types_default()).bool,
    label: (prop_types_default()).string
};
ButtonTradingFill.defaultProps = {
    isActive: false,
    minimize: false,
    label: "START TRADING"
};
/* harmony default export */ var InitialTrading_ButtonTradingFill = (ButtonTradingFill);

;// CONCATENATED MODULE: ./src/global/Header/InitialTrading/Web.jsx









var InitialTradeWeb = function(_param) {
    var minimize = _param.minimize, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "minimize"
    ]);
    var router = (0,next_router.useRouter)();
    var showAuthModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var activeRoutes = [
        "/securities/register/information",
        "/securities/auth",
        "/securities/login", 
    ];
    var activeByDefault = activeRoutes.some(function(value) {
        return router.asPath.includes(value);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* PopoverCustom */.Bp, {
        componentTrigger: function(isButtonActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialTrading_ButtonTradingFill, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
                isActive: isButtonActive || activeByDefault,
                label: "START TRADING",
                minimize: minimize,
                onClick: function() {
                    return showAuthModal();
                }
            }));
        }
    });
};
InitialTradeWeb.propTypes = {
    minimize: (prop_types_default()).bool
};
InitialTradeWeb.defaultProps = {
    minimize: true
};
/* harmony default export */ var Web = (InitialTradeWeb);

// EXTERNAL MODULE: ./src/global/Header/InitialTrading/Mobile.jsx
var Mobile = __webpack_require__(65743);
;// CONCATENATED MODULE: ./src/global/Header/InitialTrading/index.jsx



// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/lib/stores/multiPorto.ts
var multiPorto = __webpack_require__(34385);
// EXTERNAL MODULE: ./src/features/multi-porto/hooks/useSubAccounts.ts
var useSubAccounts = __webpack_require__(65361);
// EXTERNAL MODULE: ./src/features/multi-porto/hooks/useSwitchAction.ts
var useSwitchAction = __webpack_require__(74981);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/features/multi-porto/components/SwitchPopover/index.tsx + 3 modules
var SwitchPopover = __webpack_require__(71378);
// EXTERNAL MODULE: ./src/features/securities/withdrawal/utils.ts
var utils = __webpack_require__(17921);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var securities_utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/SwitchAccount/switch.styled.ts

function switch_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    switch_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function switch_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    switch_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid #f1f1f1;\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px;\n  gap: 16px;\n  width: 284px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row;\n  justify-content: space-evenly;\n  gap: 8px;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 4px;\n  flex: 1;\n\n  h1, p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 19px;\n  }\n\n  h1 {\n    color: #858585;\n    font-family: ProximaNovaRg;\n    text-wrap: nowrap;\n  }\n\n  p {\n    color: #333333;\n    font-weight: 700;\n  }\n\n  .ant-skeleton,\n  .ant-skeleton-input {\n    height: 19px;\n    border-radius: 4px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 6px;\n  border-radius: 4px;\n  padding: 5px 8px;\n  cursor: pointer;\n  user-select: none;\n  border: 1px solid #ededed;\n  \n  span {\n    color: #00AB6B;\n    font-size: 14px;\n    line-height: 19px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bakcground: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  height: 35px;\n  cursor: pointer;\n  gap: 8px;\n\n  :hover {\n    background: #F7F7F7;\n    border-radius: 4px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var switch_styled_Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e614833-0"
})(switch_styled_templateObject());
var FlexColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e614833-1"
})(switch_styled_templateObject1());
var Container = (0,styled_components_browser_esm/* default */.ZP)(FlexColumn).withConfig({
    componentId: "sc-4e614833-2"
})(_templateObject2());
var SwitchContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexColumn).withConfig({
    componentId: "sc-4e614833-3"
})(_templateObject3());
var SwitchInfoContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexColumn).withConfig({
    componentId: "sc-4e614833-4"
})(_templateObject4());
var SwitchInfoItem = (0,styled_components_browser_esm/* default */.ZP)(FlexColumn).withConfig({
    componentId: "sc-4e614833-5"
})(_templateObject5());
var CreateButton = (0,styled_components_browser_esm/* default */.ZP)(switch_styled_Flex).withConfig({
    componentId: "sc-4e614833-6"
})(_templateObject6());
var TransferContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexColumn).withConfig({
    componentId: "sc-4e614833-7"
})(_templateObject7());
var TransferButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e614833-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/SwitchAccount/index.tsx











function SwitchAccount(param) {
    var _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    var tradingBalance = (0,multiPorto/* default */.Z)(function(s) {
        return s.tradingBalanceData.data;
    });
    var tradingBalanceLoading = (0,multiPorto/* default */.Z)(function(s) {
        return s.tradingBalanceData.isLoading;
    });
    var ref = (0,useSubAccounts/* default */.Z)(), subAccounts = ref.subAccounts, approvedSubAccounts = ref.approvedSubAccounts, subAccountError = ref.subAccountError;
    var subAccountsLength = approvedSubAccounts.length;
    var ref1 = (0,useSwitchAction/* default */.Z)(), onOpenTransferCash = ref1.onOpenTransferCash, onOpenTransferStock = ref1.onOpenTransferStock, onCreatePortfolio = ref1.onCreatePortfolio;
    var handleClickTransferCash = function() {
        onClick();
        onOpenTransferCash();
    };
    var handleClickTransferStock = function() {
        onClick();
        onOpenTransferStock();
    };
    var handleCreatePortfolio = function() {
        onClick();
        onCreatePortfolio();
    };
    var formatBalance = function(balance) {
        return (0,utils/* formatCurrency */.xG)(String((0,securities_utils/* getRoundDownValue */.kk)(balance, 0)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchInfoContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchInfoItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: "Total Trading Balance"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                        condition: tradingBalanceLoading && !tradingBalance.balance,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                                active: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: formatBalance(tradingBalance.balance)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchInfoItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: "Total Equity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                        condition: tradingBalanceLoading && !tradingBalance.equity,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                                active: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: formatBalance(tradingBalance.equity)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                        condition: subAccounts.length <= 1 && !subAccountError,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CreateButton, {
                            onClick: handleCreatePortfolio,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/plus/primary.svg",
                                    alt: "",
                                    width: 16,
                                    height: 16
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Create New Portfolio"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                        condition: subAccounts.length > 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchPopover/* default */.Z, {
                            hideTransfer: true,
                            width: 268,
                            placement: "bottom"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                condition: subAccountsLength > 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransferContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransferButton, {
                            onClick: handleClickTransferCash,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/multi-porto/transfer-cash.svg",
                                    alt: "",
                                    width: 14,
                                    height: 14
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Transfer Cash"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransferButton, {
                            onClick: handleClickTransferStock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/multi-porto/transfer-stock.svg",
                                    alt: "",
                                    width: 14,
                                    height: 14
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Transfer Stock"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/global/Securities/utils/auth.ts
var auth = __webpack_require__(4565);
// EXTERNAL MODULE: ./src/global/Securities/utils/maintenance.ts + 2 modules
var maintenance = __webpack_require__(38525);
// EXTERNAL MODULE: ./src/hooks/useBroadcastChannel.ts
var useBroadcastChannel = __webpack_require__(21489);
// EXTERNAL MODULE: ./src/lib/api/stockTransfer.ts
var stockTransfer = __webpack_require__(94177);
// EXTERNAL MODULE: ./src/global/Header/RealTrading/realTadingMenu.tsx
var realTadingMenu = __webpack_require__(38097);
// EXTERNAL MODULE: ./src/global/Header/RealTrading/styled.ts
var styled = __webpack_require__(39971);
;// CONCATENATED MODULE: ./src/global/Header/RealTrading/ButtonTradingOutline.tsx





var ButtonTradingOutline = function(param) {
    var isActive = param.isActive, isOpen = param.isOpen, minimize = param.minimize, label = param.label, imageSrc = param.imageSrc, onChangeVisibility = param.onChangeVisibility;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonTrading */._L, {
        "data-cy": "real-trading-btn",
        isActive: isActive && isOpen,
        minimize: minimize,
        onClick: function() {
            return onChangeVisibility(!isActive);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                size: minimize ? "20px" : "40px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: imageSrc,
                    alt: "",
                    style: {
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "space-between",
                style: {
                    gap: "4px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextLabel */.yp, {
                        minimize: minimize,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        className: "arrow",
                        src: "/icon/chevron-down.svg",
                        alt: "",
                        width: 18,
                        height: 18
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RealTrading_ButtonTradingOutline = (ButtonTradingOutline);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/features/securities/hooks/useSecuritiesButton.ts
var useSecuritiesButton = __webpack_require__(45173);
;// CONCATENATED MODULE: ./src/global/Header/RealTrading/TradingMenuItem.tsx










var TradingMenuItem = function(param) {
    var iconmoon = param.iconmoon, children = param.children, label = param.label, link = param.link;
    var router = (0,next_router.useRouter)();
    var ref = (0,useSecuritiesButton/* default */.Z)(), handleLogoutTrading = ref.handleLogoutTrading, handleClickSupportButton = ref.handleClickSupportButton;
    var handleNavigation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!link) e.preventDefault();
                        if (!(label === "Trading Logout")) {
                            _ctx.next = 4;
                            break;
                        }
                        handleLogoutTrading();
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(label === "Live Support")) {
                            _ctx.next = 7;
                            break;
                        }
                        handleClickSupportButton();
                        return _ctx.abrupt("return");
                    case 7:
                        router.push((0,general/* sanitizeURL */.lz)(link));
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleNavigation(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TradingMenuItemContainer */.Rw, {
            "data-cy": "trading-menu-item",
            onClick: handleNavigation,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                    size: "14px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                        size: "12px",
                        className: iconmoon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: "14px",
                    height: "28px",
                    padding: "0 8px",
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var RealTrading_TradingMenuItem = (TradingMenuItem);

;// CONCATENATED MODULE: ./src/global/Header/RealTrading/Web.tsx

























var Web_Web = function(_param) {
    var minimize = _param.minimize, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "minimize"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(null), lastId = ref1[0], setLastId = ref1[1];
    var ref2 = (0,react.useState)(""), transferNote = ref2[0], setTransferNote = ref2[1];
    var openSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.showModal;
    });
    var message = (0,useBroadcastChannel/* default */.Z)("multi-portfolio").message;
    var activeAccountName = (0,useSubAccounts/* default */.Z)().activeAccountName;
    var setActiveAccount = (0,multiPorto/* default */.Z)(function(s) {
        return s.setActiveAccount;
    });
    var getTradingBalance = (0,multiPorto/* default */.Z)(function(s) {
        return s.getTradingBalance;
    });
    (0,react.useEffect)(function() {
        if ((0,auth/* getUserLoginStatus */.Y)()) {
            stockTransfer/* default.getNotification */.Z.getNotification().then(function(res) {
                if (res.data.data) {
                    var _data = res.data.data, latest_pending_id = _data.latest_pending_id, notes = _data.notes;
                    setLastId(latest_pending_id);
                    setTransferNote(notes);
                }
            });
        }
    }, []);
    var handleClose = function() {
        setLastId(null);
        setTransferNote("");
    };
    var handleClickNotif = function() {
        handleClose();
        router.push("/securities/stocktransfer");
    };
    var handleBuyClick = function() {
        return (0,maintenance/* withMaintenanceGuard */.L)(function() {
            openSearchCompanyModal();
            setIsVisible(false);
        });
    };
    var handleChangeVisibility = function(active) {
        setIsVisible(active);
        if (active) {
            getTradingBalance();
        }
    };
    (0,react.useEffect)(function() {
        if (message && message.type === "refetch-portfolio") {
            setActiveAccount(message.message);
        }
    }, [
        message
    ]);
    var stockbitLogoUrl = "/img/ssd.svg";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* PopoverCustom */.Bp, {
        componentTrigger: function(isButtonActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_ButtonTradingOutline, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
                isActive: isButtonActive,
                isOpen: isVisible,
                minimize: minimize,
                label: activeAccountName || "Trading Area",
                imageSrc: stockbitLogoUrl,
                onChangeVisibility: handleChangeVisibility
            }));
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
            condition: isVisible,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PopoverContainerBlock */.Kf, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: lastId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* StockTransferNotif */.b1, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: "trading-menu-notification",
                                    onClick: handleClickNotif,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            alt: "notification-illustration",
                                            src: "/images/cloud-document-blue.svg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: transferNote
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "trading-menu-notification-close",
                                    onClick: handleClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        alt: "close-x",
                                        src: "/icon/x-bold-blue.svg"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonBuyWrapper */.HE, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "primary",
                            height: "40px",
                            block: true,
                            onClick: handleBuyClick,
                            style: {
                                borderRadius: "4px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: color/* default.light */.Z.light,
                                size: "14px",
                                family: "bold",
                                align: "center",
                                children: "BUY"
                            })
                        })
                    }),
                    realTadingMenu/* default.map */.Z.map(function(param, i) {
                        var title = param.title, subMenu = param.subMenu;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TradeAreaContent */.vG, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                    condition: !!title,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TradingMenuTitle */._T, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            color: color/* default.primary */.Z.primary,
                                            children: title
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                    condition: i === 0,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchAccount, {
                                        onClick: function() {
                                            return setIsVisible(false);
                                        }
                                    })
                                }),
                                subMenu.map(function(param, index) {
                                    var iconmoonWeb = param.iconmoonWeb, label = param.label, link = param.link, flag = param.flag;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: !flag && /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_TradingMenuItem, {
                                            iconmoon: iconmoonWeb,
                                            label: label,
                                            link: link,
                                            children: label
                                        })
                                    }, "trading-menu-item-".concat(index + 1));
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {
                                    className: "divider"
                                })
                            ]
                        }, "trade-area-content-".concat(i + 1));
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var RealTrading_Web = (Web_Web);

// EXTERNAL MODULE: ./src/global/Header/RealTrading/Mobile.tsx + 11 modules
var RealTrading_Mobile = __webpack_require__(87671);
;// CONCATENATED MODULE: ./src/global/Header/RealTrading/index.tsx



// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/lib/analytics/virtualTrading.ts
var virtualTrading = __webpack_require__(29351);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/types.ts
var types = __webpack_require__(41110);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOpeningAccountStore.ts
var useOpeningAccountStore = __webpack_require__(8948);
// EXTERNAL MODULE: ./src/global/Header/VirtualTrading/virtualTradingMenu.js
var virtualTradingMenu = __webpack_require__(66980);
// EXTERNAL MODULE: ./src/global/Header/VirtualTrading/styled.js
var VirtualTrading_styled = __webpack_require__(39035);
;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/ButtonTradingOutline.jsx










var virtualAreaImg = "data:image/svg+xml;base64,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";
var ButtonTradingOutline_ButtonTradingOutline = function(_param) /*#__PURE__*/ {
    var isActive = _param.isActive, minimize = _param.minimize, label = _param.label, imageSrc = _param.imageSrc, onChangeVisibility = _param.onChangeVisibility, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "isActive",
        "minimize",
        "label",
        "imageSrc",
        "onChangeVisibility"
    ]);
    return (0,jsx_runtime.jsxs)(VirtualTrading_styled/* ButtonTrading */._L, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isActive: isActive,
        minimize: minimize,
        onClick: function() {
            return onChangeVisibility(!isActive);
        }
    }, otherProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                size: "50px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: label === "Virtual Area" ? virtualAreaImg : imageSrc,
                    alt: "",
                    style: {
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "13px",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                        size: "16px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-toolbar_down"
                        })
                    })
                ]
            })
        ]
    }));
};
ButtonTradingOutline_ButtonTradingOutline.propTypes = {
    isActive: (prop_types_default()).bool.isRequired,
    minimize: (prop_types_default()).bool.isRequired,
    label: (prop_types_default()).string.isRequired,
    imageSrc: (prop_types_default()).string.isRequired,
    onChangeVisibility: (prop_types_default()).func.isRequired
};
/* harmony default export */ var VirtualTrading_ButtonTradingOutline = (ButtonTradingOutline_ButtonTradingOutline);

;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/TradingMenuItem.jsx








var TradingMenuItem_TradingMenuItem = function(_param) /*#__PURE__*/ {
    var iconmoon = _param.iconmoon, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "iconmoon",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(VirtualTrading_styled/* TradingMenuItemContainer */.Rw, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                size: "14px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                    size: "12px",
                    className: iconmoon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "14px",
                height: "28px",
                padding: "0 8px",
                children: children
            })
        ]
    }));
};
TradingMenuItem_TradingMenuItem.propTypes = {
    iconmoon: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var VirtualTrading_TradingMenuItem = (TradingMenuItem_TradingMenuItem);

// EXTERNAL MODULE: ./src/global/Header/styled.js
var Header_styled = __webpack_require__(46990);
;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/Web.tsx




























var VirtualTrading_Web_Web = function(_param) {
    var minimize = _param.minimize, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "minimize"
    ]);
    var router = (0,next_router.useRouter)();
    var showAuthModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var showSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.showModal;
    });
    var oaStatus = (0,useOpeningAccountStore/* default */.Z)(function(s) {
        return s.status;
    });
    var isStockbitSecuritas = oaStatus === types/* AuthModalStatus.COMPLETED */.X.COMPLETED;
    var handleNavigation = function(label, link) {
        router.push((0,general/* sanitizeURL */.lz)(link));
    };
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var analyticsNavigate = function(label) {
        switch(label){
            case "Orderbook":
                virtualTrading/* virtualTradingAction.onVirtualTradingOrderbookSelected */.SP.onVirtualTradingOrderbookSelected();
                break;
            case "Portfolio":
                virtualTrading/* virtualTradingAction.onVirtualTradingPortfolioSelected */.SP.onVirtualTradingPortfolioSelected();
                break;
            case "Order":
                virtualTrading/* virtualTradingAction.onVirtualTradingOrderSelected */.SP.onVirtualTradingOrderSelected();
                break;
            default:
                break;
        }
    };
    var handleSwitchReal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 2:
                        if (![
                            "/trade/portfolio/",
                            "/trade/order/"
                        ].includes(router.asPath)) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 5;
                        return router.push("/stream");
                    case 5:
                        showAuthModal();
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSwitchReal() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* PopoverCustom */.Bp, {
        componentTrigger: function(isButtonActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_ButtonTradingOutline, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
                "data-cy": "virtual-trading-btn",
                isActive: isButtonActive,
                minimize: minimize,
                label: "Virtual Area",
                imageSrc: "".concat(api/* SITE_URL */._O, "/img/favicon.svg"),
                onChangeVisibility: function(active) {
                    return setIsVisible(active);
                }
            }));
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
            condition: isVisible,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VirtualTrading_styled/* PopoverContainerBlock */.Kf, {
                children: [
                    virtualTradingMenu/* default.map */.Z.map(function(param, i) {
                        var title = param.title, subMenu = param.subMenu;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VirtualTrading_styled/* TradeAreaContent */.vG, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_styled/* TradingMenuTitle */._T, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        family: "bold",
                                        color: color/* default.primary */.Z.primary,
                                        children: title
                                    })
                                }),
                                i === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        padding: "8px 16px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "primary",
                                        height: "32px",
                                        block: true,
                                        onClick: function() {
                                            showSearchCompanyModal();
                                            setIsVisible(false);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: color/* default.light */.Z.light,
                                            size: "14px",
                                            family: "bold",
                                            align: "center",
                                            children: "BUY"
                                        })
                                    })
                                }),
                                subMenu.map(function(param, index) {
                                    var iconmoonWeb = param.iconmoonWeb, label = param.label, link = param.link;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_TradingMenuItem, {
                                        iconmoon: iconmoonWeb,
                                        onClick: function() {
                                            handleNavigation(label, link);
                                            analyticsNavigate(label);
                                        },
                                        children: label
                                    }, "trading-menu-item-".concat(index + 1));
                                })
                            ]
                        }, "trade-area-content-".concat(i + 1));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_styled/* TradeAreaContent */.vG, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-cy": "switch-to-real-account-btn",
                            style: {
                                padding: "0px 16px"
                            },
                            onClick: function() {
                                handleSwitchReal();
                                virtualTrading/* virtualTradingAction.onSwitchToRealTradingSelected */.SP.onSwitchToRealTradingSelected(virtualTrading/* SWITCH_TO_REAL_ACCOUNT_SOURCE.dropdownVirtualArea */.S_.dropdownVirtualArea, isStockbitSecuritas);
                            },
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_styled/* SwitchButton */.U3, {
                                height: "32px",
                                block: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: color/* default.primary */.Z.primary,
                                            size: "14px",
                                            padding: "0 8px",
                                            children: "Switch to Real Account"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                                            size: "18px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                                className: "icon-tradesmall_switch",
                                                size: "12px",
                                                color: color/* default.primary */.Z.primary
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var VirtualTrading_Web = (VirtualTrading_Web_Web);

// EXTERNAL MODULE: ./src/global/Header/VirtualTrading/Mobile.tsx
var VirtualTrading_Mobile = __webpack_require__(13263);
;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/index.jsx



// EXTERNAL MODULE: ./src/global/Header/SearchCompanyModal/index.tsx + 1 modules
var SearchCompanyModal = __webpack_require__(80567);
;// CONCATENATED MODULE: ./src/global/Header/Web.jsx
















// header components












// header styled

var srcImage = "/img/stockbit.svg";
var lastYOffset = 0;
function Header_Web_Web(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isHeaderMinimized = param.isHeaderMinimized, isMarketOpen = param.isMarketOpen;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,useTradingAccount/* default */.Z)(), isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading, tradingType = ref.tradingType;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), data = ref1.data, isLoading = ref1.isLoading;
    var _country = data.country, country = _country === void 0 ? "ID" : _country;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return [
            s.visible,
            s.closeModal
        ];
    }, shallow/* default */.Z), 2), isShowSearchCompanyModal = ref2[0], closeSearchCompanyModal = ref2[1];
    var showTradingModal = (0,store/* default */.Z)(function(s) {
        return s.showModal;
    });
    var getUnreadCount = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.getUnreadCount;
    });
    (0,react.useEffect)(function() {
        var onDocumentScroll = function() {
            var currentYOffset = window.pageYOffset;
            var canScroll = document.documentElement.scrollHeight > window.innerHeight;
            if (!canScroll) {
                dispatch(slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(false));
            }
            if (currentYOffset < 150) return;
            if (currentYOffset > lastYOffset && !isHeaderMinimized) {
                // down
                dispatch(slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(true));
            } else if (currentYOffset < lastYOffset && isHeaderMinimized) {
                // up
                dispatch(slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(false));
            }
            lastYOffset = currentYOffset;
        };
        window.addEventListener("scroll", onDocumentScroll);
        // Clean eventlistener when unmount component
        return function() {
            window.removeEventListener("scroll", onDocumentScroll);
        };
    }, [
        dispatch,
        isHeaderMinimized
    ]);
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            getUnreadCount();
        }
    }, []);
    (0,react.useEffect)(function() {
        return function() {
            dispatch(slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(false));
        };
    }, []);
    var renderTradingPopup = function() {
        if (isRealTrading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_Web, {
                minimize: isHeaderMinimized
            });
        }
        if (isVirtualTrading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Web, {
                minimize: isHeaderMinimized
            });
        }
        if (!tradingType) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Web, {
                minimize: isHeaderMinimized
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    };
    var onSymbolChange = function(newSymbol) {
        closeSearchCompanyModal();
        showTradingModal({
            symbol: newSymbol,
            orderType: isRealTrading ? trading/* ORDER_TYPE.BUY */.Jm.BUY : trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY,
            modalData: {
                source: "Other"
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_styled/* HeaderWeb */.q8, {
        id: "stockbit-header-web",
        isOpen: isSideWidgetOpen,
        isMarketOpen: isMarketOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_styled/* HeaderWebTop */.xn, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/stream",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    alt: "",
                                                    src: srcImage,
                                                    style: {
                                                        height: "40px",
                                                        marginRight: "30px",
                                                        width: "75px"
                                                    }
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* Web */.p, {
                                        style: {
                                            padding: "0 30px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                children: [
                                    !isLoading && !data.ispro ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/shop",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_styled/* ProUser */.cA, {
                                            children: "Berlangganan Pro"
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* Web */.p, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification/* Web */.p, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu/* Web */.p, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Web */.p, {
                        minimize: isHeaderMinimized
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: country === "ID",
                children: renderTradingPopup()
            }),
            isShowSearchCompanyModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompanyModal/* default */.Z, {
                onSymbolChange: function(symbol) {
                    return onSymbolChange(symbol);
                }
            })
        ]
    });
}
Header_Web_Web.propTypes = {
    isSideWidgetOpen: (prop_types_default()).bool,
    isHeaderMinimized: (prop_types_default()).bool,
    isMarketOpen: (prop_types_default()).bool
};
Header_Web_Web.defaultProps = {
    isSideWidgetOpen: false,
    isHeaderMinimized: false,
    isMarketOpen: false
};
/* harmony default export */ var Header_Web = (Header_Web_Web);


/***/ }),

/***/ 8948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var lib_api_securities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65906);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91635);







var initialState = {
    status: null
};
var useOpeningAccountStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        resetStore: function() {
            return set({
                status: null
            });
        },
        loadAccountStatus: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res, ref, ref1, data, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_securities__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getOAStatus */ .Z.getOAStatus();
                    case 3:
                        res = _ctx.sent;
                        ;
                        ref1 = (ref = res === null || res === void 0 ? void 0 : res.data) !== null && ref !== void 0 ? ref : {}, data = ref1.data, _$error = ref1.error;
                        if (!(!data || _$error)) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to get oa status failed");
                    case 8:
                        set({
                            status: data.status
                        });
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,utils_logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_ctx.t0, {
                            event: "useOpeningAccountStore@loadAccountStatus",
                            errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useOpeningAccountStore);


/***/ }),

/***/ 29351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ VIRTUAL_TRADING_SOURCE; },
/* harmony export */   "SP": function() { return /* binding */ virtualTradingAction; },
/* harmony export */   "S_": function() { return /* binding */ SWITCH_TO_REAL_ACCOUNT_SOURCE; },
/* harmony export */   "Y0": function() { return /* binding */ ORDER_EXPIRY; },
/* harmony export */   "f9": function() { return /* binding */ virtualTradingNavigate; },
/* harmony export */   "gT": function() { return /* binding */ VIRTUAL_TRADING_TYPES; },
/* harmony export */   "ub": function() { return /* binding */ PORTFOLIOS_TYPE; }
/* harmony export */ });
/* unused harmony exports VIRTUAL_TRADING_NAVIGATE, VIRTUAL_TRADING_ACTION, SYMBOL_TYPES, ORDER_FILTER, virtualTradingEvents */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var VIRTUAL_TRADING_NAVIGATE = {
    buyOrderViewed: "Buy Order Viewed",
    portfolioViewed: "Portfolio Viewed",
    sellOrderViewed: "Sell Order Viewed",
    portfolioOrderViewed: "Portfolio Order Viewed",
    orderDetailViewed: "Order Detail Viewed",
    amendOrderViewed: "Amend Order Viewed"
};
var VIRTUAL_TRADING_ACTION = {
    virtualTradingAction: "Virtual Trading Action",
    startTradingSelected: "Start Trading Selected",
    virtualTradingSelected: "Virtual Trading Selected",
    switchToRealTradingSelected: "Switch To Real Trading Selected",
    virtualTradingOrderbookSelected: "Virtual Trading Orderbook Selected",
    virtualTradingPortfolioSelected: "Virtual Trading Portfolio Selected",
    virtualTradingOrderSelected: "Virtual Trading Order Selected",
    buyOrderPlaced: "Buy Order Placed",
    buyOrderCanceled: "Buy Order Canceled",
    portfolioBuyMoreSelected: "Portfolio Buy More Selected",
    portfolioSellStockSelected: "Portfolio Sell Stock Selected",
    portfolioViewChartSelected: "Portfolio View Chart Selected",
    portfolioSetPriceAlert: "Portfolio Set Price Alert Selected",
    portfolioStockSelected: "Portfolio Stock Selected",
    sellOrderPlaced: "Sell Order Placed",
    orderDetailCancelOrderSelected: "Order Detail Cancel Order Selected",
    orderDetailAmendSelected: "Order Detail Amend Selected",
    amendOrderPlaced: "Amend Order Placed"
};
var VIRTUAL_TRADING_TYPES = {
    virtualTrading: "Virtual Trading",
    realTrading: "Real Trading"
};
var SYMBOL_TYPES = {
    right: "Right",
    warrant: "Warrant",
    normal: "Normal"
};
var VIRTUAL_TRADING_SOURCE = {
    watchlist: "Watchlist",
    portfolio: "Portfolio",
    predictionPost: "Prediction Post",
    companyPage: "Company Page",
    chartbit: "Chartbit"
};
var SWITCH_TO_REAL_ACCOUNT_SOURCE = {
    orderModal: "Order Modal",
    dropdownVirtualArea: "Dropdown 'Virtual Area'"
};
var ORDER_FILTER = {
    order: "Order",
    exercise: "Exercise",
    cashback: "Cashback"
};
var ORDER_EXPIRY = {
    goodForDay: "Good for day",
    goodTillCanceled: "Good till canceled"
};
var PORTFOLIOS_TYPE = {
    regular: "Regular",
    dayTrade: "Day Trade",
    both: "Both",
    none: "None"
};
var virtualTradingEvents = {
    onSwitchToVirtualTrading: function() {
        var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Switch To Virtual Selected";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: action
        });
    }
};
var virtualTradingNavigate = {
    onBuyOrderViewes: function(Symbol, Source, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.buyOrderViewed, {
            Symbol: Symbol,
            Source: Source,
            Type: Type
        });
    },
    onPortfolioViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioViewed, {
            Type: Type
        });
    },
    onSellOrderViewed: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.sellOrderViewed, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioOrderViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioOrderViewed, {
            Type: Type
        });
    },
    onOrderDetailViewed: function(param) {
        var OrderType = param.OrderType, Status = param.Status, _RejectReason = param.RejectReason, RejectReason = _RejectReason === void 0 ? "" : _RejectReason, Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.orderDetailViewed, {
            "Order Type": OrderType,
            Status: Status,
            "Reject Reason": RejectReason,
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderViewed: function(param) {
        var Symbol = param.Symbol, OrderType = param.OrderType, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.amendOrderViewed, {
            Symbol: Symbol,
            "Order Type": OrderType,
            Type: Type
        });
    }
};
var virtualTradingAction = {
    onStartTradingSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.startTradingSelected
        });
    },
    onVirtualTradingSelected: function(isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingSelected,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onSwitchToRealTradingSelected: function(Source, isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.switchToRealTradingSelected,
            Source: Source,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onVirtualTradingOrderbookSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderbookSelected
        });
    },
    onVirtualTradingPortfolioSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingPortfolioSelected
        });
    },
    onVirtualTradingOrderSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderSelected
        });
    },
    onBuyOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.buyOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onBuyOrderCanceled: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.buyOrderCanceled,
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onPortfolioBuyMoreSelected: function(param) {
        var Symbol = param.Symbol, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioBuyMoreSelected, {
            Symbol: Symbol,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onPortfolioSellStockSelected: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSellStockSelected, {
            Type: Type
        });
    },
    onPortfolioViewChartSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioViewChartSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioSetPriceAlert: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSetPriceAlert, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioStockSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioStockSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onSellOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.sellOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onOrderDetailCancelOrderSelected: function(Symbol) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailCancelOrderSelected, {
            Symbol: Symbol
        });
    },
    onOrderDetailAmendSelected: function(param) {
        var Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailAmendSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.amendOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Type: Type
        });
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    virtualTradingEvents: virtualTradingEvents
});


/***/ }),

/***/ 94177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18364);
/* eslint-disable no-undef */ /* eslint-disable camelcase */ /* eslint-disable import/named */ 

var request = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
var STOCK_TRANSFER_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_SECURITIES_GENERAL_URL */ .kg, "/stock-transfer");
/**
 * Get securities login token
 * @return {APIResponse}
 */ var getStockTransferExist = function() {
    return request.get("".concat(STOCK_TRANSFER_URL, "/is-exist"));
};
var getTransactionList = function(type) {
    return request.get("".concat(STOCK_TRANSFER_URL, "/transactions"), {
        params: {
            type: type
        }
    });
};
var getTransactionDetail = function(stockTransferId) {
    return request.get("".concat(STOCK_TRANSFER_URL, "/v2/transactions/").concat(stockTransferId));
};
// 1: All; 2: Default; 3: Others
var getSecuritiesList = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
    return request.get("".concat(STOCK_TRANSFER_URL, "/securities"), {
        params: {
            query_type: type
        }
    });
};
var getForm = function(securityCode, transferId) {
    return request.get("".concat(STOCK_TRANSFER_URL, "/v2/form"), {
        params: {
            security_code: securityCode,
            stock_transfer_id: transferId
        }
    });
};
var postTransaction = function(data) {
    return request.post("".concat(STOCK_TRANSFER_URL, "/v2/transactions"), {
        stock_transfer_data: data
    });
};
var cancelTransaction = function(stockTransferId) {
    return request.post("".concat(STOCK_TRANSFER_URL, "/transactions/cancel"), {
        stock_transfer_id: stockTransferId
    });
};
var getUploadToken = function(securityCode) {
    return request.get("".concat(STOCK_TRANSFER_URL, "/upload/token"), {
        params: {
            security_code: securityCode
        }
    });
};
var uploadImage = function(url, body) {
    return fetch(url, {
        method: "POST",
        body: body
    });
};
var getNotification = function() {
    return request.get("".concat(STOCK_TRANSFER_URL, "/notifications"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getStockTransferExist: getStockTransferExist,
    getTransactionList: getTransactionList,
    getTransactionDetail: getTransactionDetail,
    getSecuritiesList: getSecuritiesList,
    getForm: getForm,
    postTransaction: postTransaction,
    cancelTransaction: cancelTransaction,
    getUploadToken: getUploadToken,
    uploadImage: uploadImage,
    getNotification: getNotification
});


/***/ })

}]);